import "./profile.css";
import { useSelector } from "react-redux";
import { Outlet, Navigate } from "react-router-dom";

const Profile = () => {
  const { data: user } = useSelector((store) => store.auth);


  // redirect user if already subscribed
  if (user.subscribed || user.adminSubscribed) {
    return <Navigate to="/myAccount/home" replace />;
  }
  return (
    <div className="text_white text_center signup_card">
      <Outlet />
    </div>
  );
};

export default Profile;
